import { render } from "./shippingDetailTable.vue?vue&type=template&id=4fc235cc"
import script from "./shippingDetailTable.vue?vue&type=script&lang=js"
export * from "./shippingDetailTable.vue?vue&type=script&lang=js"

import "./shippingDetailTable.vue?vue&type=style&index=0&id=4fc235cc&lang=less&scope=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__